import script from "./ImageLabel.view.vue?vue&type=script&lang=ts&setup=true"
export * from "./ImageLabel.view.vue?vue&type=script&lang=ts&setup=true"

import "./ImageLabel.view.vue?vue&type=style&index=0&id=c980543e&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c980543e"]])

export default __exports__